import {
  getCancellableSubscriptionCard,
  getCancelSurveySubscriptionType,
} from '@griply/utils';
import { useMemo } from 'react';

import { useSubscriptionCards } from './use-subscription-cards';

export const useCancellableSubscriptionCard = () => {
  const cards = useSubscriptionCards();

  return useMemo(() => {
    const card = getCancellableSubscriptionCard(cards);

    return {
      card,
      variant: card ? getCancelSurveySubscriptionType(card) : null,
    };
  }, [cards]);
};
